import React from 'react'
import { NoticeProtected } from '@fs/zion-icon'
import { H3, InfoSheet, Separator, useInfoSheet } from '@fs/zion-ui'
import TimeTravelInfoSheet from './TimeTravelInfoSheet'
import ChangeCountryInfoSheet from './ChangeCountryInfoSheet'
import ChangePermissionsInfoSheet from './ChangePermissionsInfoSheet'
import FixedButton from './FixedButton'
import RainbowText from '../RainbowText'

const QAInfoSheet = () => {
  const infoSheet = useInfoSheet()

  const flavor = 'dusk'

  return (
    <>
      <FixedButton
        ariaLabel="Open Quality Assurance Options"
        Icon={NoticeProtected}
        onClick={infoSheet.handleClick}
        flavor={flavor}
      />

      <InfoSheet
        {...infoSheet}
        size="md"
        title={
          <H3 size="H4">
            <RainbowText flavor={flavor}>QA Options</RainbowText>
          </H3>
        }
      >
        <TimeTravelInfoSheet />
        <Separator />
        <ChangeCountryInfoSheet />
        <Separator />
        <ChangePermissionsInfoSheet />
      </InfoSheet>
    </>
  )
}

export default QAInfoSheet
